import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, Eyebrow, MaskLine } from "./Primitives";
import { scrollToId } from "../../lib/site";

const SERVICES = [
  {
    id: "presencial", n: "01", title: "Personal Presencial", img: "/img/presencial.jpg",
    desc: "Atendimento individual, lado a lado, com correção de técnica em cada repetição.",
    items: ["Avaliação física inicial", "Treino 100% individual", "Correção de execução em tempo real"],
    span: "lg:col-span-7 lg:row-span-2", h: "min-h-[540px]",
  },
  {
    id: "online", n: "02", title: "Consultoria Online", img: "/img/online.jpg",
    desc: "Seu treino onde você estiver, com acompanhamento e ajustes à distância.",
    items: ["Planilha personalizada", "Suporte pelo WhatsApp", "Ajustes periódicos"],
    span: "lg:col-span-5", h: "min-h-[440px]",
  },
  {
    id: "mista", n: "03", title: "Consultoria Mista", img: "/img/mista.jpg",
    desc: "O melhor dos dois formatos: aulas presenciais combinadas com acompanhamento online.",
    items: ["Aulas presenciais periódicas", "Treino online entre as aulas", "Suporte pelo WhatsApp"],
    span: "lg:col-span-5", h: "min-h-[440px]",
  },
];

const Card = ({ s, onPick }) => (
  <article className={`group relative flex h-full flex-col justify-end overflow-hidden border border-white/10 bg-[var(--ink-3)] p-6 md:p-8 ${s.h}`} data-testid={`service-card-${s.id}`}>
    <img src={s.img} alt={s.title} className="absolute inset-0 h-full w-full object-cover opacity-55 grayscale transition-[transform,opacity,filter] duration-700 group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-[#0a0a0c]/70 to-[#0a0a0c]/10" />
    <div className="absolute left-6 top-6 font-mono text-xs tracking-[0.2em] text-zinc-300 md:left-8 md:top-8">{s.n} / 03</div>
    <div className="relative">
      <h3 className="font-display text-4xl font-900 uppercase leading-[0.9] md:text-6xl">{s.title}</h3>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-300 md:text-base">{s.desc}</p>
      <ul className="mt-5 space-y-2">
        {s.items.map((it) => (
          <li key={it} className="flex items-center gap-2 text-sm text-zinc-200"><Check className="h-4 w-4 text-[var(--red)]" />{it}</li>
        ))}
      </ul>
      <button onClick={() => onPick(s.title)} data-testid={`service-cta-${s.id}`}
        className="mt-7 inline-flex items-center gap-2 border border-white/25 px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] transition-colors hover:border-[var(--red)] hover:bg-[var(--red)] hover:text-[#0a0a0c]">
        Quero este plano <ArrowUpRight className="h-4 w-4" />
      </button>
    </div>
  </article>
);

export const Services = ({ onPick }) => {
  const pick = (title) => { onPick(title); scrollToId("agendar"); };
  return (
    <section id="servicos" className="relative px-5 py-24 md:px-10 md:py-32" data-testid="services-section">
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-14 flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <div>
            <Eyebrow index="02">Serviços</Eyebrow>
            <h2 className="mt-8 font-display text-5xl font-900 uppercase leading-[0.9] sm:text-6xl lg:text-8xl">
              <MaskLine inView>Três formas</MaskLine>
              <MaskLine inView delay={0.1}>de <span className="text-[var(--red)]">evoluir.</span></MaskLine>
            </h2>
          </div>
          <Reveal><p className="max-w-sm text-base leading-relaxed text-zinc-400">Escolha o formato que encaixa na sua rotina. Todos começam com uma aula experimental.</p></Reveal>
        </div>
        <div className="grid gap-4 lg:grid-cols-12">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.1} className={s.span}><Card s={s} onPick={pick} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
